import { ROOT_NODE as RN } from '@craftjs/core';

export const ROOT_NODE = RN;
export const DEFAULT_LINE_HEIGHT_VALUE = 1.25; // TODO: reference ./constants.ts
export * from './types';
